import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("{{#if this.shouldBeDisplayed}}\n  <DebugWidget::Widget ...attributes />\n{{/if}}",{ moduleName: "cio/components/debug-widget/index.hbs" })